const apiKey = process.env;

async function getAllDoctors(params){
    const apiUrl = apiKey.REACT_APP_API_URL;
    //const url = params ? `${apiUrl}/getAlldoctors/${params}` : `${apiUrl}/getAlldoctors`;
    const url = params ? `${apiUrl}/getFilteredDoctor/${params}` : `${apiUrl}/getFilteredDoctor`;
    const data = await fetch(url);
  const result = await data.json();
  return result;
}
async function getSelectedDoctors(params){
  const apiUrl = apiKey.REACT_APP_API_URL;
  const data = await fetch(`${apiUrl}/getFilteredDoctor/${params.page}/${params.dept}`);
const result = await data.json();
return result.data
}

module.exports = { getAllDoctors, getSelectedDoctors }
